const $27f33e380669b1e3$var$textRef = document.querySelector(".text");
let $27f33e380669b1e3$var$count = 0;
let $27f33e380669b1e3$var$id = null;
$27f33e380669b1e3$var$id = setInterval(()=>{
    $27f33e380669b1e3$var$count += 1;
    $27f33e380669b1e3$var$textRef.textContent = $27f33e380669b1e3$var$count;
    if ($27f33e380669b1e3$var$count > 5) {
        clearInterval($27f33e380669b1e3$var$id);
        $27f33e380669b1e3$var$textRef.textContent = `0, interval stoped`;
    }
}, 1000);


const $ef2ab4351c5690cc$var$boxesRef = document.querySelectorAll(".boxes");
let $ef2ab4351c5690cc$var$index = 0;
setInterval(()=>{
    $ef2ab4351c5690cc$var$boxesRef.forEach((el)=>el.classList.remove("active"));
    $ef2ab4351c5690cc$var$boxesRef[$ef2ab4351c5690cc$var$index].classList.add("active");
    $ef2ab4351c5690cc$var$index++;
    if ($ef2ab4351c5690cc$var$index >= $ef2ab4351c5690cc$var$boxesRef.length) $ef2ab4351c5690cc$var$index = 0;
}, 1000);


const $5ba0c14c4be34fb8$var$count = document.querySelector(".con");
const $5ba0c14c4be34fb8$var$gameBoxes = document.querySelectorAll(".game-box");
let $5ba0c14c4be34fb8$var$number = 0;
let $5ba0c14c4be34fb8$var$activeIndex = 0;
const $5ba0c14c4be34fb8$var$intervalId = setInterval(()=>{
    $5ba0c14c4be34fb8$var$gameBoxes.forEach((el)=>el.classList.remove("is-active"));
    $5ba0c14c4be34fb8$var$activeIndex = Math.floor(Math.random() * $5ba0c14c4be34fb8$var$gameBoxes.length);
    $5ba0c14c4be34fb8$var$gameBoxes[$5ba0c14c4be34fb8$var$activeIndex].classList.add("is-active");
}, 1000);
$5ba0c14c4be34fb8$var$gameBoxes.forEach((el)=>{
    el.addEventListener("click", (e)=>{
        if (e.currentTarget.classList.contains("is-active")) {
            $5ba0c14c4be34fb8$var$number += 1;
            $5ba0c14c4be34fb8$var$count.textContent = $5ba0c14c4be34fb8$var$number;
        }
    });
});
setTimeout(()=>{
    $5ba0c14c4be34fb8$var$count.textContent = 0;
    $5ba0c14c4be34fb8$var$number = 0;
    $5ba0c14c4be34fb8$var$gameBoxes.forEach((el)=>el.classList.remove("is-active"));
    clearInterval($5ba0c14c4be34fb8$var$intervalId);
    console.log("stop");
}, 10000);


const $9237f314ea22f26f$var$input = document.querySelector(".ipt");
const $9237f314ea22f26f$var$btn = document.querySelector(".button");
$9237f314ea22f26f$var$btn.addEventListener("click", ()=>{
    let values = $9237f314ea22f26f$var$input.value * 1000;
    setTimeout(()=>{
        alert(`Your value: ${values}`);
    }, values);
});




//# sourceMappingURL=10hw-js.f005a260.js.map
